import { useState, useRef } from 'react';
import logo from '../../../assets/logo.png';

export default function Profile({ profilePic, setProfilePic }) {
  const [bio, setBio] = useState("Hey! I'm Aryan, a freelance developer and AI specialist from Patna, Bihar. I build professional websites, train AI models, and provide research paper services under my brand LathiNyx DevLabs.");
  const [editing, setEditing] = useState(false);
  const [signature, setSignature] = useState(null);
  const fileRef = useRef(null);
  const signRef = useRef(null);

  const handlePicUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => setProfilePic && setProfilePic(ev.target.result);
    reader.readAsDataURL(file);
  };

  const handleSignUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => setSignature(ev.target.result);
    reader.readAsDataURL(file);
  };

  return (
    <div>
      {/* Banner */}
      <div className="d-profile-banner">
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 20, flexWrap: 'wrap' }}>
          <div className="d-pic-upload-wrap">
            <div className="d-profile-avatar">
              {profilePic
                ? <img src={profilePic} alt="Profile" />
                : <span>AR</span>
              }
            </div>
            <button className="d-pic-upload-btn" onClick={() => fileRef.current.click()} title="Upload photo">📷</button>
            <input ref={fileRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handlePicUpload} />
          </div>
          <div style={{ flex: 1 }}>
            <h2 style={{ fontSize: 24, fontWeight: 800, marginBottom: 4 }}>Aryan</h2>
            <p style={{ fontSize: 14, opacity: 0.9, marginBottom: 4, fontWeight: 600 }}>Founder of LathiNyx DevLabs™</p>
            <p style={{ fontSize: 13, opacity: 0.75 }}>Full Stack Developer · AI Specialist · Research Expert</p>
            <p style={{ marginTop: 6, fontSize: 13, opacity: 0.75 }}>📧 lathinyxdevlabs@gmail.com &nbsp;|&nbsp; 📍 Patna, Bihar</p>
            <p style={{ marginTop: 3, fontSize: 13, opacity: 0.75 }}>🌐 lathinyxdevlabs.com</p>
          </div>
          <img src={logo} alt="LathiNyx DevLabs" style={{ height: 52, width: 'auto', objectFit: 'contain', opacity: 0.9, alignSelf: 'flex-start' }} />
        </div>
        <div className="d-pstat-grid">
          {[['3+', 'Total Projects'], ['3', 'Completed'], ['3+', 'Clients'], ['4.9★', 'Rating']].map(([num, label]) => (
            <div key={label} className="d-pstat"><div className="pnum">{num}</div><div className="plabel">{label}</div></div>
          ))}
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <div className="d-card">
          <div className="d-ctitle">Skills & Expertise</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
            {['HTML/CSS/JS','React','Node.js','WordPress','UI/UX Design','Web Deployment','SEO'].map(s => <span key={s} className="d-tag tw">{s}</span>)}
            {['AI Model Training','Dataset Prep','NLP','Prompt Engineering'].map(s => <span key={s} className="d-tag ta">{s}</span>)}
            {['Research Writing','Plagiarism Removal','Literature Review'].map(s => <span key={s} className="d-tag tr-tag">{s}</span>)}
          </div>
        </div>

        <div className="d-card">
          <div className="d-ctitle">Quick Stats — 2025</div>
          {[['Projects Done', '60%', '#1800ad', '3 total'], ['Active Now', '40%', '#4ecba0', '1'], ['Pending', '20%', '#e8a000', '1'], ['Client Rating', '92%', '#4ecba0', '⭐ 4.9']].map(([label, w, color, val]) => (
            <div key={label} className="d-sbar-row">
              <span style={{ fontSize: 13, width: 110, color: '#333' }}>{label}</span>
              <div className="d-sbar-wrap"><div className="d-sbar" style={{ width: w, background: color }} /></div>
              <span style={{ fontSize: 13, color: '#1a1a1a', fontWeight: 600 }}>{val}</span>
            </div>
          ))}
        </div>

        <div className="d-card" style={{ gridColumn: '1/-1' }}>
          <div className="d-ctitle">About Me</div>
          {editing ? (
            <>
              <textarea className="d-finput" rows={4} value={bio} onChange={e => setBio(e.target.value)} style={{ marginBottom: 10 }} />
              <button className="d-btn d-btn-primary" style={{ fontSize: 13 }} onClick={() => setEditing(false)}>Save Bio</button>
            </>
          ) : (
            <>
              <p style={{ fontSize: 14, color: '#333', lineHeight: 1.7 }}>{bio}</p>
              <button className="d-btn d-btn-primary" style={{ marginTop: 12, fontSize: 13 }} onClick={() => setEditing(true)}>✏️ Edit Bio</button>
            </>
          )}
        </div>

        {/* Digital Signature */}
        <div className="d-card" style={{ gridColumn: '1/-1' }}>
          <div className="d-ctitle">Digital Signature</div>
          <p style={{ fontSize: 13, color: '#555', marginBottom: 14 }}>Upload your signature image (PNG with transparent background recommended). It will be used on all generated documents.</p>
          <div className="d-sign-upload" onClick={() => signRef.current.click()}>
            {signature
              ? <img src={signature} alt="Signature" className="d-sign-preview" />
              : <>
                  <div style={{ fontSize: 28 }}>✍️</div>
                  <p>Click to upload signature image</p>
                  <p style={{ fontSize: 12, color: '#aaa' }}>PNG, JPG — transparent background preferred</p>
                </>
            }
          </div>
          <input ref={signRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleSignUpload} />
          {signature && (
            <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
              <button className="d-btn d-btn-primary d-btn-sm" onClick={() => signRef.current.click()}>🔄 Replace Signature</button>
              <button className="d-btn d-btn-danger d-btn-sm" onClick={() => setSignature(null)}>✕ Remove</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
